import React from 'react';
import { arrayOf, bool, object, number, string, oneOf } from 'prop-types';
import classnames from 'classnames';
import ClientLogo from '../ClientLogo';
import { getClientLogoPath, COMPACT_BAR, HIDDEN_CLIENTS_MODE } from '../../../utils/helpers/notableClients';
import './style.scss';

const CompactClientList = ({
    displayClients = [],
    hiddenClientsMode = HIDDEN_CLIENTS_MODE.DOTS,
    showCompanyNames = false,
    logoSize = ClientLogo.SIZES.TINY,
    limit = COMPACT_BAR.CLIENTS_LIMIT,
    logoClassName = ''
}) => {
    const lastIndex = Math.min(displayClients.length, limit) - 1;
    const hasHiddenClients = displayClients.length > limit;
    const hiddenClientsLength = displayClients.length - limit;

    const renderHiddenClients = () => {
        switch (hiddenClientsMode) {
            case HIDDEN_CLIENTS_MODE.DOTS:
                return (
                    <span className={classnames('list-dots', { 'title-spacing': showCompanyNames })}>
                        {[...Array(COMPACT_BAR.ELLIPSIS_COUNT)].map((value, index) => (<span key={`dot_${index}`} className="dot"/>))}
                    </span>
                );
            case HIDDEN_CLIENTS_MODE.PLUS:
                const classNames = classnames(
                    'flex-center',
                    'bg-co-grey-300',
                    'co-text-darker',
                    'tbody-6',
                    'text-semi-bold',
                    logoSize,
                    'plus-more',
                    { 'title-spacing': showCompanyNames }
                );

                return <p className={classNames}>+{hiddenClientsLength}</p>;
            default:
                return null;
        }
    };

    return (
        <div className="notable-clients-compact-logo-list">
            {displayClients.slice(0, limit).map((client, index) => {
                const { name } = client.enriched_details;
                const logoPath = getClientLogoPath(client);
                const logoProps = { logoPath, name, logoClassName, size: logoSize };

                if (!hasHiddenClients && (index === lastIndex)) {
                    logoProps.logoContainerClassName = 'no-margin';
                }

                return (
                    <span key={logoPath} className={classnames('flex', { 'client-wrapper': showCompanyNames })}>
                        <ClientLogo {...logoProps}/>
                        {showCompanyNames && <p className="client-title m-l-8 co-text-darkest">{name}</p>}
                    </span>
                );
            })}
            {hasHiddenClients && renderHiddenClients()}
        </div>
    );
};

CompactClientList.propTypes = {
    displayClients: arrayOf(object),
    hiddenClientsMode: oneOf(Object.values(HIDDEN_CLIENTS_MODE)),
    showCompanyNames: bool,
    limit: number,
    logoSize: oneOf(Object.values(ClientLogo.SIZES)),
    logoClassName: string
};

export default CompactClientList;
